// src/components/SetupDemo.js
// Temporary component to set up demo employees
import React, { useState } from 'react';
import { Box, Button, Typography, Alert, CircularProgress } from '@mui/material';
import setupEmployees from '../utils/setupEmployees';

export default function SetupDemo() {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSetup = async () => {
    setLoading(true);
    setMessage('');
    setError('');

    try {
      await setupEmployees();
      setMessage('Demo employees created successfully! You can now use the login credentials.');
    } catch (err) {
      setError('Error setting up demo employees: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', p: 4 }}>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Demo Setup
      </Typography>
      
      <Typography variant="body1" sx={{ mb: 3 }}>
        Click the button below to create demo employee accounts in Firebase.
        This only needs to be done once.
      </Typography>

      {message && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {message}
        </Alert>
      )}

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Button 
        variant="contained" 
        onClick={handleSetup}
        disabled={loading}
        size="large"
        sx={{ mr: 2 }}
      >
        {loading ? <CircularProgress size={24} /> : 'Setup Demo Employees'}
      </Button>

      <Box sx={{ mt: 3, p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          Demo Credentials (after setup):
        </Typography>
        <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
          Email: john.doe@restaurant.com<br />
          Password: demo123
        </Typography>
        <Typography variant="body2" sx={{ fontFamily: 'monospace', mt: 1 }}>
          Email: jane.smith@restaurant.com<br />
          Password: demo123
        </Typography>
      </Box>
    </Box>
  );
}
